import {GUEST_USER, AUTH_USER, GET_ERRORS, SET_CURRENT_USER, JUST_PAID, LOGOUT_USER, LOADER_STATUS, AUTH_USER_APPOINTMENTS, DOCTOR_SEARCH_LIST_LENGTH} from "../actions";
import jwt_decode from "jwt-decode";

const initialState = {
    isLoaderActive: false,
    isAuthenticated: localStorage.jwtToken ? true : false,
    lengthOfDoctorSearchList: 0,
    user: localStorage.jwtToken  
    ? jwt_decode(localStorage.jwtToken)
    : {},
    userData: {},
    guest: {
         isGuest: localStorage.jwtToken ? false : true, 
         address:localStorage.getItem("address")
         ? JSON.parse(localStorage.getItem("address"))
         : {},
         checkout_list:localStorage.getItem("guest_checkout_list")
         ? JSON.parse(localStorage.getItem("guest_checkout_list"))
         : {},
        },
    loading: false,
    just_paid: false,
    errors: false,
}

const isEmpty = require("is-empty");

export default (state = initialState, { type, payload }) => {
    switch (type) {
    case GET_ERRORS:
        return {
            ...state,
            errors: payload,
        };

    case SET_CURRENT_USER:
        return {
            ...state,
            guest: { isGuest: false, },
            isAuthenticated: !isEmpty(payload),
            user: payload,
        };   
        
        case JUST_PAID:
            return {
                ...state,
                just_paid: payload,
            };   
        
    case GUEST_USER:
        return { ...state, 
            guest: payload, 
        }
    
    case AUTH_USER:
        return {
            ...state,
            guest: { isGuest: false, },
            userData: payload,
        };

        case AUTH_USER_APPOINTMENTS:
            return {
                ...state,
                guest: { isGuest: false, },
                userData: {...state.userData, appointments:payload},
            };
        case LOADER_STATUS:
            return {
                ...state,
                isLoaderActive: payload,
            };
        case DOCTOR_SEARCH_LIST_LENGTH:
            return{
                ...state,
                lengthOfDoctorSearchList: payload,
            }
        case LOGOUT_USER:
      return { ...state };
    default:
        return state
    }
}
